import * as React from 'react';
import * as styles from './MortgageBanner.css';
import { LinkButton, useDeviceType } from '@cian/ui-kit';
import { ILinkButtonProps } from '@cian/ui-kit/button/types';
import mortgageLogo from './assets/logo.svg';
import { trackMortgageBannerClick } from './tracking';

const MORTGAGE_LINK = 'https://www.cian.ru/ipoteka-main/?utm_medium=country-builders-projects';

export const MortgageBanner: React.FC = () => {
  const deviceType = useDeviceType();

  const buttonProps = React.useMemo<ILinkButtonProps>(() => {
    switch (deviceType) {
      case 'desktop':
        return { size: 'L', target: '_blank' };
      case 'tablet':
        return { size: 'L' };
      case 'phone':
        return { size: 'M', fullWidth: true };
    }
  }, [deviceType]);

  return (
    <div className={styles['mortgage-banner']}>
      <img className={styles['logo']} src={mortgageLogo} />
      <div className={styles['inner']}>
        <div className={styles['title']}>Ипотека на строительство домов</div>
        <div className={styles['description']}>Выгодные программы господдержки</div>
        <LinkButton {...buttonProps} theme="fill_primary" href={MORTGAGE_LINK} onClick={trackMortgageBannerClick}>
          Узнать свои ставки
        </LinkButton>
      </div>
    </div>
  );
};
